import React from "react";
import PropTypes from "prop-types";

import {
  HeaderContainer,
  HeaderTitle,
  HeaderSiteLogo,
} from "./pageHeaderStyles.js";
import { getSiteSpecificLogo } from "./sitesByID.js";

export const PageHeader = ({ title, siteId }) => {
  const getLogo = () => {
    const siteLogo = getSiteSpecificLogo(siteId);

    return (
      <img
        src={siteLogo.siteLogoSrc}
        alt={siteLogo.site}
        style={{ height: "3rem" }}
      />
    );
  };

  return (
    <HeaderContainer>
      {/* Breadcrumbs - Future Story */}
      <HeaderTitle>{title}</HeaderTitle>
      <HeaderSiteLogo>{getLogo()}</HeaderSiteLogo>
    </HeaderContainer>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  siteId: PropTypes.number,
};
